export const SUPPORT_EMAIL = 'support@medyoucate.com';
